import "core-js/modules/es.array.every";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { asyncRouterHandle } from '@/utils/asyncRouter';
import { asyncMenu } from '@/api/menu';
var routerList = [];

var formatRouter = function formatRouter(routes) {
  routes && routes.map(function (item) {
    if ((!item.children || item.children.every(function (ch) {
      return ch.hidden;
    })) && item.name !== '404') {
      routerList.push({
        label: item.meta.title,
        value: item.name
      });
    }

    if (item.children && item.children.length > 0) {
      formatRouter(item.children);
    }
  });
};

export var router = {
  namespaced: true,
  state: {
    asyncRouters: [],
    routerList: routerList,
    keepAliveList: []
  },
  mutations: {
    setRouterList: function setRouterList(state, routerList) {
      state.routerList = routerList;
    },
    // 设置动态路由
    setAsyncRouter: function setAsyncRouter(state, asyncRouters) {
      state.asyncRouters = asyncRouters;
    },
    // 设置动态路由
    setKeepAliveList: function setKeepAliveList(state, keepAliveList) {
      state.keepAliveList = keepAliveList;
    }
  },
  actions: {
    // 从后台获取动态路由
    SetAsyncRouter: function SetAsyncRouter(_ref) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var commit, baseRouter, asyncRouterRes, Admin, asyncRouter;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit;
                baseRouter = [{
                  path: '/layout',
                  name: 'layout',
                  component: 'view/layout/index.vue',
                  meta: {
                    title: '底层layout'
                  },
                  children: []
                }];
                _context.next = 4;
                return asyncMenu();

              case 4:
                asyncRouterRes = _context.sent;

                if (!(asyncRouterRes.code !== 0)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                Admin = asyncRouterRes.data.menus.filter(function (item) {
                  return item.name === 'Admin';
                });
                asyncRouter = Admin[0].children;
                asyncRouter.push({
                  path: '404',
                  name: '404',
                  hidden: true,
                  meta: {
                    title: '迷路了*。*'
                  },
                  component: 'view/error/index.vue'
                });
                formatRouter(asyncRouter);
                baseRouter[0].children = asyncRouter;
                baseRouter.push({
                  path: '*',
                  redirect: '/layout/404'
                });
                asyncRouterHandle(baseRouter);
                console.log('baseRouter', baseRouter);
                commit('setAsyncRouter', baseRouter);
                commit('setRouterList', routerList);
                return _context.abrupt("return", true);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    // 获取动态路由
    asyncRouters: function asyncRouters(state) {
      return state.asyncRouters;
    },
    routerList: function routerList(state) {
      return state.routerList;
    },
    defaultRouter: function defaultRouter(state) {
      return state.defaultRouter;
    },
    keepAliveList: function keepAliveList(state) {
      return state.keepAliveList;
    }
  }
};